export type CreateFileLayoutRequest = {
  dtKindId: string;
  cmpId: string;
  converterType: string;
};
